export const GET_AUTHORIZATION_CODE = 'GET_AUTHORIZATION_CODE';
export const AUTHORIZATION_CODE_SUCCESS = 'AUTHORIZATION_CODE_SUCCESS';
export const CHECK_CONNECTED_TOKEN_EXTERNAL_USER = 'CHECK_CONNECTED_TOKEN_EXTERNAL_USER';
export const GET_EXTERNAL_TOOL_URL_FROM_TOKEN = 'GET_EXTERNAL_TOOL_URL_FROM_TOKEN';


